import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import DivIcon from 'react-leaflet-div-icon';
import {CircleMarker} from 'react-leaflet';
import {getCentroidForSpot} from '../../utils';
import {zoomByCoordinates} from '../../actions/parkingSpots';

class ReservedSpotMarker extends Component {

  render() {
    const {spotId, zoomByCoordinates} = this.props;
    const centroid = getCentroidForSpot(spotId);

    return (
      <DivIcon position={[centroid.lat, centroid.lng]}
               className="spot-marker-container"
               onClick={() => zoomByCoordinates(centroid)} >
        <div className={'spot-marker-wrap myspot-pulse'}>
          <div className={'i-icon-marker-pin-myspot marker-icon-div'} />
        </div>
      </DivIcon>
    );
  }

}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({zoomByCoordinates}, dispatch);
};

export default connect(undefined, mapDispatchToProps)(ReservedSpotMarker);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ReservedSpotMarker.js